import { useAtomValue } from 'jotai';

import { t } from '../service/i18n';
import { langAtom } from '../state/lang';

type TransProps = {
  children: string;
};

export const Trans = ({ children }: TransProps) => {
  const code = useAtomValue(langAtom);

  return <>{t(code, children)}</>;
};
